import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const QuickbooksIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Quickbooks",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16 2C8.27 2 2 8.27 2 16s6.27 14 14 14 14-6.27 14-14S23.73 2 16 2m-.78 23.18a2.02 2.02 0 0 1-2.02-2.02V12.58h-1.87c-1.89 0-3.42 1.53-3.42 3.42s1.53 3.42 3.42 3.42h.78v2.02h-.78a5.44 5.44 0 1 1 0-10.88h3.89zm5.44-3.73h-3.89V6.82c1.12 0 2.02.91 2.02 2.02v10.58h1.87c1.89 0 3.42-1.53 3.42-3.42s-1.53-3.42-3.42-3.42h-.78v-2.02h.78a5.44 5.44 0 1 1 0 10.88Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M16 0C7.18 0 0 7.18 0 16s7.18 16 16 16 16-7.18 16-16S24.82 0 16 0m0 2.46c7.49 0 13.54 6.05 13.54 13.54S23.49 29.54 16 29.54 2.46 23.49 2.46 16 8.51 2.46 16 2.46m1.23 4.93v14.77h4.92c2.82 0 4.92-2.59 4.92-5.54s-2.11-5.54-4.92-5.54v2.46c1.26 0 2.46 1.27 2.46 3.08s-1.2 3.08-2.46 3.08h-2.46V7.39zM9.85 9.85c-2.82 0-4.92 2.59-4.92 5.54s2.11 5.54 4.92 5.54v-2.46c-1.26 0-2.46-1.27-2.46-3.08s1.2-3.08 2.46-3.08h2.46v12.31h2.46V9.85z"
      })
    })
  }));
};
QuickbooksIcon.displayName = 'QuickbooksIcon';